module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9020HD_white-fc56cb13e195dd15fdece83975a81cb6.png";